export default __webpack_public_path__ + "static/NuvemFiscalHome2-6dd60d715ee18c035345500d220b2e17.png";